import React from 'react';
import ToolbarComponent from './components/toolbar/index';
import './style.css';
import { startOfDay } from 'date-fns';
import MovementsTable from './components/movements-table/index';

export default class MovementsComponent extends React.Component {
    state = {
        start: startOfDay(new Date()),
        end: startOfDay(new Date()),
    }

    handleChange = (event, date, name) => {
        let newState = Object.assign({}, this.state)
        newState[name] = startOfDay(date)
        this.setState(newState)
    };

    render() {
        return (
            <div className="Movements">
                <ToolbarComponent handleChange={this.handleChange}
                    start={this.state.start} end={this.state.end} />
                <div className="movements-container">
                    <div className="card">
                        <div className="card-content">
                            <MovementsTable start={this.state.start} end={this.state.end} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/movements/index.js